import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPeople } from "redux/KPIs/peopleSlice";

import { currencyFormatter } from "../helpers";
import { NoTeamLabel } from "views/KPIs";
import { updateBonusPeriod } from "components/Apis/KPIs";
import { fetchBonusPeriods } from "redux/KPIs/bonusPeriodSlice";
import toast, { Toaster } from "react-hot-toast"
import { fetchTerminals } from "redux/warehouse/terminalSlice";

export const Company = () => {
    const people = useSelector((state) => state.KPIPeopleReducer.people);
    const quarter = useSelector((state) => state.KPIFilterReducer.quarter);
    const bonusPeriod = useSelector((state) => state.KPIBonusPeriodSlice.bonusPeriod);
    const { loading, terminals, error } = useSelector((state) => state.TerminalSlice);
    const dispatch = useDispatch();

    useEffect(() => {
        if (quarter) {
            dispatch(fetchPeople(quarter));
            dispatch(fetchBonusPeriods(quarter));
        }
        if (!terminals.length) {
            dispatch(fetchTerminals());
        }
    }, [quarter, dispatch]);


    const updateBonusPeriodData = async (record) => {
        await updateBonusPeriod(
            quarter,
            {
                id: bonusPeriod.id,
                kpi_data: {
                    ...bonusPeriod.kpi_data,
                    ...record,
                }
            }
        )
        setTimeout(() => {
            dispatch(fetchBonusPeriods(quarter));
        }, 300);
    }

    return (
        <>
            <table className="kpis-goals-table w-100">
                <thead>
                    <tr                    >
                        <th>Load Count</th>
                        <th>QTD</th>
                        <th>Load Count Goal</th>
                        <th>Goal Completion</th>
                    </tr>
                </thead>
                <tbody>
                    {people &&
                        people
                            .filter(team => team.name === NoTeamLabel)  // Filter people whose team name is not "NoTeamLabel"
                            .map((team, index) => (
                                <React.Fragment key={index}>
                                    <tr
                                        className={`kpi-team-row company-row`}
                                    >
                                        <td style={{ fontWeight: "bold" }}>
                                            <div className="team-name">
                                                Company
                                            </div>
                                        </td>
                                        <td>
                                            {Number(team.invoice_count) + Number(bonusPeriod?.kpi_data?.brokerage_load_count || 0)}
                                        </td>
                                        <td>
                                            {Number(team.invoice_count_goal) + Number(bonusPeriod?.kpi_data?.brokerage_load_count_goal || 0)}
                                        </td>
                                        <td>
                                            {(Number(team.invoice_count_goal) + Number(bonusPeriod?.kpi_data?.brokerage_load_count_goal || 0)) > 0
                                                ? `${Math.round(100 * parseFloat(Number(team.invoice_count) + Number(bonusPeriod?.kpi_data?.brokerage_load_count || 0)) / parseFloat(Number(team.invoice_count_goal) + Number(bonusPeriod?.kpi_data?.brokerage_load_count_goal || 0)))}%`
                                                : 'N/A'}
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                    {people &&
                        people
                            .filter(team => team.name === NoTeamLabel)  // Filter people whose team name is not "NoTeamLabel"
                            .map((team, index) => (
                                <React.Fragment key={index}>
                                    <tr
                                        className={`kpi-team-row`}
                                    >
                                        <td style={{ fontWeight: "bold" }}>
                                            <div className="team-name">
                                                {`${team.name}`}
                                            </div>
                                        </td>
                                        <td>{team.invoice_count}</td>
                                        <td>{team.invoice_count_goal}</td>
                                        <td>
                                            {team.invoice_count_goal > 0
                                                ? `${Math.round(100 * parseFloat(team.invoice_count) / parseFloat(team.invoice_count_goal))}%`
                                                : 'N/A'}
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                    <tr
                        className={`kpi-team-row`}
                    >
                        <td style={{ fontWeight: "bold" }}>
                            <div className="team-name">
                                Brokerage
                            </div>
                        </td>
                        <td>
                            <input
                                className="kpi-input"
                                defaultValue={bonusPeriod?.kpi_data?.brokerage_load_count}
                                onBlur={(e) => {
                                    const value = e.target.value;
                                    // Call the API if the value is valid
                                    updateBonusPeriodData({
                                        brokerage_load_count: value
                                    })
                                }}
                            />
                        </td>
                        {/* <td>{currencyFormatter.format(321.2)}</td> */}
                        <td>
                            <input
                                className="kpi-input"
                                defaultValue={bonusPeriod?.kpi_data?.brokerage_load_count_goal}
                                onBlur={(e) => {
                                    const value = e.target.value;
                                    // Call the API if the value is valid
                                    updateBonusPeriodData({
                                        brokerage_load_count_goal: value
                                    })
                                }}
                            />
                        </td>
                        <td>
                            {bonusPeriod?.kpi_data?.brokerage_load_count_goal > 0
                                ? `${Math.round(100 * parseFloat(bonusPeriod?.kpi_data?.brokerage_load_count) / parseFloat(bonusPeriod?.kpi_data?.brokerage_load_count_goal))}%`
                                : 'N/A'}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="row">
                <div className="col-lg-6 col-md-12">
                    <table className="kpis-goals-table w-100 mt-4">
                        <thead>
                            <tr                    >
                                <th>Team</th>
                                <th>Gross Profit Goal</th>
                                <th>Gross Profit</th>
                                <th>Gross Profit Goal Completion</th>
                            </tr>
                        </thead>
                        <tbody>
                            {people &&
                                people.map((team, index) => (
                                    <React.Fragment key={index}>
                                        <tr
                                            className={`kpi-team-row ${team.name === NoTeamLabel ? 'company-row' : ''}`}
                                        >
                                            <td style={{ fontWeight: "bold" }}>
                                                <div className="team-name">
                                                    {`[${team.members.length}] ${team.name}`}
                                                </div>
                                            </td>
                                            <td>{currencyFormatter.format(team.gross_profit_goal)}</td>
                                            <td>{currencyFormatter.format(team.gross_profit)}</td>
                                            <td>
                                                {team.gross_profit_goal > 0
                                                    ? `${Math.round(100 * parseFloat(team.gross_profit) / parseFloat(team.gross_profit_goal))}%`
                                                    : 'N/A'}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                        </tbody>
                    </table>
                </div>
                <div className="col-lg-6 col-md-12">
                    <table className="kpis-goals-table w-100 mt-4">
                        <thead>
                            <tr                    >
                                <th>Warehouse Service Failures</th>
                                <th>QTD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {terminals && terminals.map((terminal, index) => (
                                <>
                                    <tr>
                                        <td style={{ fontWeight: "bold" }}>
                                            <div className="team-name">
                                                {`${terminal.name}`}
                                            </div>
                                        </td>
                                        <td>
                                            <input
                                                className="kpi-input"
                                                defaultValue={bonusPeriod?.kpi_data?.[`service_failures_terminal_${terminal.name}`]}
                                                onBlur={(e) => {
                                                    const value = e.target.value;
                                                    // Call the API if the value is valid
                                                    updateBonusPeriodData({
                                                        [`service_failures_terminal_${terminal.name}`]: value,
                                                    });
                                                }}
                                            />
                                        </td>
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                    <table className="kpis-goals-table w-100 mt-4">
                        <thead>
                            <tr                    >
                                <th>Company driver Minimums</th>
                                <th>QTD</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ fontWeight: "bold" }}>
                                    Not Enough Miles
                                </td>
                                <td>
                                    <input
                                        className="kpi-input"
                                        defaultValue={bonusPeriod?.kpi_data?.not_enough_miles}
                                        onBlur={(e) => {
                                            const value = e.target.value;
                                            // Call the API if the value is valid
                                            updateBonusPeriodData({
                                                not_enough_miles: value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold" }}>
                                    Equipment Breakdowns
                                </td>
                                <td>
                                    <input
                                        className="kpi-input"
                                        defaultValue={bonusPeriod?.kpi_data?.equipment_breakdowns}
                                        onBlur={(e) => {
                                            const value = e.target.value;
                                            // Call the API if the value is valid
                                            updateBonusPeriodData({
                                                equipment_breakdowns: value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};
